import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    fontWeight: 'bold',
  },
  success: {
    backgroundColor: '#e1efd9',
    borderLeft: `solid 4px ${theme.palette.common.success}`,
    color: theme.palette.common.success,
  },
  error: {
    backgroundColor: '#efccd2',
    borderLeft: `solid 4px ${theme.palette.common.error}`,
    color: theme.palette.common.error,
  },
  warning: {
    backgroundColor: '#fdf0cc',
    borderLeft: `solid 4px ${theme.palette.common.warning}`,
    color: theme.palette.common.warning,
  },
}));

const ToastMessage = (props) => {
  const classes = useStyles(props);
  return (
    <div className={classNames(classes.root, classes[props.type])}>
      {props.message}
    </div>
  );
};

ToastMessage.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ToastMessage;
